export const DEFAULT_HIDE_TIME = 2000;
